export default __webpack_public_path__ + "static/media/juice.47f800c4.png";